import React from 'react';
import ReactDOM from 'react-dom/client';
// Dependencias antes servidas por CDN externo en index.html, ahora bundleadas
// (evita depender de dominios de terceros — ver el incidente de polyfill.io).
import '@fortawesome/fontawesome-free/css/all.min.css'; // íconos `fa*` (antes cdnjs)
import 'moment/locale/es'; // locale español de moment (antes el es.js del cdnjs)
import App from './App';
import './i18n'; // inicializa i18next (idiomas) antes de renderizar la app
import "./components/viewUserModal/viewUserModal.scss";
import reportWebVitals from './reportWebVitals';

// Suprimir errores de CORS en la consola del navegador
// Esto es necesario porque el backend no está configurado para CORS
// y el navegador muestra estos errores de forma agresiva
if (typeof window !== 'undefined') {
  // Interceptar console.error para filtrar errores de CORS
  const originalError = console.error;
  console.error = function(...args) {
    const errorMessage = args.join(' ');
    // Filtrar errores de CORS conocidos
    if (
      errorMessage.includes('Access to XMLHttpRequest') ||
      errorMessage.includes('CORS policy') ||
      errorMessage.includes('Access-Control-Allow-Origin') ||
      errorMessage.includes('preflight request') ||
      errorMessage.includes('has been blocked by CORS policy') ||
      (errorMessage.includes('from origin') && errorMessage.includes('has been blocked'))
    ) {
      // Silenciar estos errores específicos de CORS
      return;
    }
    // Para otros errores, usar el console.error original
    originalError.apply(console, args);
  };

  // Interceptar errores no capturados del navegador
  window.addEventListener('error', (event) => {
    const errorMessage = event.message || '';
    if (
      errorMessage.includes('CORS') ||
      errorMessage.includes('Access-Control-Allow-Origin') ||
      errorMessage.includes('preflight request') ||
      errorMessage.includes('blocked by CORS policy')
    ) {
      // Prevenir que el error se muestre en la consola
      event.preventDefault();
      return false;
    }
  }, true);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
